// Role mapping and labels
export const ROLES = {
  manager_cabang: 'Manager Cabang',
  admin_maintenance: 'Admin Maintenance',
  admin_purchasing: 'Admin Purchasing',
  admin_it: 'Admin IT',
  admin_gudang: 'Admin Gudang',
  finance: 'Finance',
  super_admin: 'Super Admin',
};

export const ROLE_OPTIONS = Object.entries(ROLES).map(([value, label]) => ({
  value,
  label,
}));

// Full label map — includes DEPRECATED categories (petty_cash, refund_deposit)
// so that tiket LAMA yang sudah pakai kategori itu tetap tampil dengan label yang benar.
// Kategori DEPRECATED tidak muncul di dropdown pembuatan tiket baru (lihat TICKET_CATEGORY_OPTIONS).
export const TICKET_CATEGORIES = {
  umum: 'Umum',
  it: 'IT',
  me: 'ME (Mechanical/Electrical)',
  petty_cash: 'Petty Cash',                 // deprecated — dipecah jadi petty_cash_in / petty_cash_out
  refund_deposit: 'Refund Deposit',         // deprecated — dipecah jadi deposit_in / deposit_out
  utility_payment: 'Pembayaran Utility (Listrik/Air/Internet)',
  transfer_operasional: 'Transfer Operasional Lainnya',
  petty_cash_in: 'Petty Cash (IN)',
  petty_cash_out: 'Petty Cash (OUT)',
  deposit_in: 'Deposit (IN)',
  deposit_out: 'Deposit (OUT)',
};

export const CATEGORY_DESCRIPTIONS = {
  umum: 'Kebutuhan umum operasional cabang',
  it: 'Perangkat / sistem IT',
  me: 'Mechanical / Electrical (AC, listrik, plumbing)',
  petty_cash: 'Pengajuan dana kecil untuk operasional',
  refund_deposit: 'Pengembalian deposit tamu',
  utility_payment: 'Pembayaran tagihan listrik, air, internet, dll',
  transfer_operasional: 'Transfer dana operasional lainnya',
  petty_cash_in: 'Petty Cash masuk (penambahan kas kecil)',
  petty_cash_out: 'Petty Cash keluar (pengeluaran kas kecil)',
  deposit_in: 'Deposit masuk (penerimaan deposit tamu)',
  deposit_out: 'Deposit keluar / pengembalian deposit tamu',
};

// Kategori aktif untuk dropdown BUAT TIKET BARU — tanpa petty_cash & refund_deposit (deprecated).
const ACTIVE_TICKET_CATEGORIES = [
  'umum',
  'it',
  'me',
  'utility_payment',
  'transfer_operasional',
  'petty_cash_in',
  'petty_cash_out',
  'deposit_in',
  'deposit_out',
];

export const TICKET_CATEGORY_OPTIONS = ACTIVE_TICKET_CATEGORIES.map((value) => ({
  value,
  label: TICKET_CATEGORIES[value],
}));

// Kategori pengeluaran untuk INVOICE (wajib diisi saat generate invoice).
// Terpisah dari kategori tiket — dipakai Finance untuk merekap pengeluaran.
export const INVOICE_EXPENSE_CATEGORIES = [
  'Gaji & Benefit',
  'Listrik',
  'Telepon, Internet & Kabel Vision',
  'House Keeping',
  'Laundry',
  'Marketing',
  'Air Minum Isi Ulang',
  'Breakfast',
  'Perawatan Bangunan dan Peralatan',
  'Lain Lain',
  'Capex',
  'Refund Deposit',
];

export const INVOICE_EXPENSE_CATEGORY_OPTIONS = INVOICE_EXPENSE_CATEGORIES.map((v) => ({
  value: v,
  label: v,
}));

export const URGENCY_LEVELS = {
  rendah: { label: 'Rendah', color: 'bg-slate-100 text-slate-700 border-slate-300' },
  sedang: { label: 'Sedang', color: 'bg-blue-100 text-blue-700 border-blue-300' },
  tinggi: { label: 'Tinggi', color: 'bg-amber-100 text-amber-700 border-amber-300' },
  urgent: { label: 'Urgent', color: 'bg-red-100 text-red-700 border-red-300' },
};

export const URGENCY_OPTIONS = Object.entries(URGENCY_LEVELS).map(([value, { label }]) => ({
  value,
  label,
}));

export const TICKET_STATUSES = {
  draft: { label: 'Draft', color: 'bg-slate-100 text-slate-700', step: 1 },
  pending_approval: { label: 'Menunggu Approval', color: 'bg-amber-100 text-amber-700', step: 2 },
  approved: { label: 'Disetujui', color: 'bg-blue-100 text-blue-700', step: 3 },
  need_items: { label: 'Butuh Barang', color: 'bg-purple-100 text-purple-700', step: 3 },
  in_progress: { label: 'Sedang Dikerjakan', color: 'bg-indigo-100 text-indigo-700', step: 4 },
  waiting_confirmation: { label: 'Menunggu Konfirmasi', color: 'bg-cyan-100 text-cyan-700', step: 5 },
  completed: { label: 'Selesai', color: 'bg-green-100 text-green-700', step: 6 },
  invoiced: { label: 'Invoice Terbit', color: 'bg-emerald-100 text-emerald-700', step: 7 },
  rejected: { label: 'Ditolak', color: 'bg-red-100 text-red-700', step: 0 },
  cancelled: { label: 'Dibatalkan', color: 'bg-gray-100 text-gray-700', step: 0 },
  on_hold: { label: 'On Hold', color: 'bg-yellow-100 text-yellow-700', step: 0 },
};

export const ITEM_CATEGORIES = [
  { value: 'elektrikal', label: 'Elektrikal' },
  { value: 'plumbing', label: 'Plumbing' },
  { value: 'alat', label: 'Alat' },
  { value: 'material', label: 'Material Bangunan' },
  { value: 'ac', label: 'AC & Pendingin' },
  { value: 'kebersihan', label: 'Kebersihan' },
  { value: 'lainnya', label: 'Lainnya' },
];

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
  }).format(amount || 0);
};

export const parseServerDate = (dateStr) => {
    if (!dateStr) return null;
    const hasTimezone = /Z$|[+-]\d{2}:?\d{2}$/.test(dateStr);
    return new Date(hasTimezone ? dateStr : dateStr + 'Z');
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = parseServerDate(dateStr);
  return new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Jakarta',
  }).format(date);
};
